import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/esm/objectWithoutProperties";
/**
 *
 * RadioButton
 *
 */

import React from 'react';
import RegularRadioButton from './Regular';
import MediumRadioButton from './Medium';
import LargeRadioButton from './Large';

var RadioButton = function RadioButton(_ref) {
  var variation = _ref.variation,
      props = _objectWithoutProperties(_ref, ["variation"]);

  switch (variation) {
    case 'large':
      return React.createElement(LargeRadioButton, props);

    case 'medium':
      return React.createElement(MediumRadioButton, props);

    case 'regular':
    default:
      return React.createElement(RegularRadioButton, props);
  }
};

RadioButton.defaultProps = {
  variation: 'regular'
};
RadioButton.displayName = 'RadioButton';
export default RadioButton;